import { useMonthlyCalendar } from '@app/components/Calendars/MonthlyCalendar/hooks/useMonthlyCalendar';

export { useMonthlyCalendar };
